import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import withStyles from 'react-jss'
import { withTranslation } from 'react-i18next'
import compose from '@shopify/react-compose'

import TextInput from 'components/form/text-input'
import SelectInput from 'components/form/select-input'

import phoneNumberCountries from 'helpers/phone-number-countries'

import styles from './address-input-style'

const countries = phoneNumberCountries.map(country => ({
  id: country.name,
  name: country.name,
}))

const AddressInput = ({ name, classes, form, t}) =>
  <Fragment>
    <TextInput name={`${name}.street_1`} label={t('form.address.street_1') } />
    <TextInput name={`${name}.street_2`} label={t('form.address.street_2')} />
    <TextInput name={`${name}.city`} label={t('form.address.city')} />

    <div className={classes.postcodeWrapper}>
      <TextInput name={`${name}.postcode`} label={t('form.address.postal_code')} />
    </div>
    <div className={classes.countryWrapper}>
      <SelectInput name={`${name}.country`} label={t('form.address.country')} options={countries} />
    </div>
  </Fragment>

AddressInput.propTypes = {
  name: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
}

export default compose(
  withStyles(styles),
  withTranslation()
)(AddressInput)
